const CONTAINER_TYPE = [
	{ label: 'DRY 20', value: 'DRY_20' },
	{ label: 'DRY 40', value: 'DRY_40' },
	{ label: 'HIGH CUBE 40', value: 'HIGH_CUBE_40' },
	{ label: 'REEFER 20', value: 'REEFER_20' },
	{ label: 'REEFER 40', value: 'REEFER_40' },
	{ label: 'OPEN TOP 20', value: 'OPEN_TOP_20' },
	{ label: 'OPEN TOP 40', value: 'OPEN_TOP_40' },
	{ label: 'FLAT RACK 20', value: 'FLAT_RACK_20' },
	{ label: 'FLAT RACK 40', value: 'FLAT_RACK_40' },
];

export default CONTAINER_TYPE;
